import type { PlacementGroup } from '@/modules/adv/ad-service'
import { AppNativeSDK } from '@/modules/native-app'
import { type AdProvidersSettings, type PlatformType, type EffectiveType } from '@/types'

import { getGameDistributionAdSettings } from './game-distribution-settings'
import { getNativeAppAdSettings } from './native-app-settings'
import { getOppoAdSettings } from './oppo-settings'
import { getPartnerAdSettings } from './partner-integrations'
import { getPortalAdSettings } from './portal-settings'

export function getProvidersSettings({
    gamAccount,
    appNativeSDK,
    platform,
    effectiveType,
    isVersionAtLeast,
    isNativeBannersEnabled,
    gameDistributionGameId,
    clid,
    isAdDisabled,
    isGameDistribution,
    isOppoWL,
    isExportOnWidget,
    isPartnerEmbed,
    isNativeAppEnv,
    isGoogleProvidersEnabled,
}: {
    gamAccount: string
    appNativeSDK: AppNativeSDK | undefined
    platform: PlatformType
    effectiveType: EffectiveType | undefined
    isVersionAtLeast: (minVersions: { ios?: string; android?: string }) => boolean
    isNativeBannersEnabled: boolean
    gameDistributionGameId: string | undefined
    clid: string
    isAdDisabled: boolean | undefined
    isGameDistribution: boolean
    isOppoWL: boolean
    isExportOnWidget: boolean
    isPartnerEmbed: boolean
    isNativeAppEnv: boolean
    isGoogleProvidersEnabled: boolean
}): PlacementGroup<AdProvidersSettings>[] {
    if (isOppoWL) {
        return getOppoAdSettings(isAdDisabled, platform)
    }

    if (isGameDistribution) {
        return getGameDistributionAdSettings(gameDistributionGameId)
    }

    if (isNativeAppEnv) {
        return getNativeAppAdSettings({
            gamAccount,
            platform,
            isVersionAtLeast,
            isNativeBannersEnabled,
            appNativeSDK,
            clid,
            effectiveType,
        })
    }

    if (isPartnerEmbed) {
        return getPartnerAdSettings({
            gamAccount,
            platform,
            clid,
            effectiveType,
            isExportOnWidget,
            isGoogleProvidersEnabled,
        })
    }

    return getPortalAdSettings({
        gamAccount,
        platform,
        effectiveType,
    })
}
